import React from 'react';

type Pose = 'init' | 'mounted' | 'normal' | 'exit';

type Params = {
  pose: Pose;
  waitForImage: (id: string) => void;
  imageReady: (id: string) => void;
};

type Props = {
  children: (params: Params) => JSX.Element;
  waitForImages: boolean;
};

type State = {
  mounted: boolean;
  initDone: boolean;
  images: {
    [key: string]: boolean;
  };
};

export class AnnimStateProvider extends React.Component<Props, State> {
  private unmounted: boolean = false;

  constructor(props: Props) {
    super(props);
    this.state = {
      mounted: false,
      initDone: false,
      images: {},
    };

    this.waitForImage = this.waitForImage.bind(this);
    this.imageReady = this.imageReady.bind(this);
  }

  render() {
    const imagesReady =
      this.props.waitForImages === false
        ? true
        : Object.keys(this.state.images).reduce((acc, imgId) => {
            if (acc === false || this.state.images[imgId] !== true) {
              return false;
            }
            return true;
          }, true);

    const pose: Pose = (() => {
      if (this.state.mounted === false) {
        return 'init';
      }
      if (this.state.initDone === false || imagesReady === false) {
        return 'mounted';
      }
      return 'normal';
    })();
    return this.props.children({
      pose: pose,
      waitForImage: this.waitForImage,
      imageReady: this.imageReady,
    });
  }

  componentDidMount() {
    window.setTimeout(() => {
      if (!this.unmounted) {
        this.setState({ mounted: true });
        window.setTimeout(() => {
          if (!this.unmounted) {
            this.setState({ initDone: true });
          }
        }, 500);
      }
    }, 500);
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  private waitForImage(id: string) {
    if (this.state.images[id] !== false) {
      this.setState(s => ({ images: { ...s.images, [id]: false } }));
    }
  }

  private imageReady(id: string) {
    if (this.state.images[id] !== true) {
      this.setState(s => ({ images: { ...s.images, [id]: true } }));
    }
  }
}



// WEBPACK FOOTER //
// ./src/module/View/Content/component/ContentItems/AnnimStateProvider.tsx